import {
  DAIRY_BRAND_PROFILE_TOKEN,
  DO_GOOD_CANDLE_PROFILE_TOKEN,
  ELANA_GABRIELLE_PROFILE_TOKEN,
  KAARI_CO_PROFILE_TOKEN,
  KING_FLOYDS_PROFILE_TOKEN,
  OGGI_PROFILE_TOKEN,
  WOODSY_CRAFT_PROFILE_TOKEN,
  ZOTTER_CHOCOLATES_PROFILE_TOKEN,
} from "./p8AdvertiserData";

/** Left column in the store-type selection modal (first half of A–Z list). */
export const STORE_TYPE_OPTIONS_LEFT_COLUMN = [
  "Apparel boutique",
  "Bookstore",
  "Cafe or restaurant",
  "Fitness or yoga studio",
  "Florist or garden store",
  "Furniture store",
  "General store",
] as const;

/** Right column in the store-type selection modal (second half of A–Z list). */
export const STORE_TYPE_OPTIONS_RIGHT_COLUMN = [
  "Gift store",
  "Grocery or liquor store",
  "Home decor store",
  "Kids or toy store",
  "Pet store",
  "Spa or salon",
] as const;

/** Store types shown in the selection modal (Figma list). */
export const STORE_TYPE_OPTIONS = [
  ...STORE_TYPE_OPTIONS_LEFT_COLUMN,
  ...STORE_TYPE_OPTIONS_RIGHT_COLUMN,
] as const;

export const DEFAULT_SELECTED_STORE_TYPES = [
  "Florist or garden store",
  "Gift store",
  "Home decor store",
] as const;

export type ProductRow = {
  id: string;
  name: string;
  status: "advertising" | "excluded" | "unpublished" | "draft";
  sku: string;
  /** ISO date when the product was first added to the catalog and available to sell. */
  dateAdded: string;
  wholesalePrice: string;
  impressions: string;
  ctr: string;
  clicks: string;
  clickToOrder: string;
  imageColor: string;
};

/** Production-faithful rows from Promoted Listings Products tab (Galison-style catalog). */
export const PRODUCT_ROWS: ProductRow[] = [
  {
    id: "1",
    name: "Andy Warhol Soup Can Crayons + Sharpener",
    status: "advertising",
    sku: "9780735380110",
    dateAdded: "2023-09-15",
    wholesalePrice: "$10.39",
    impressions: "255",
    ctr: "4.3%",
    clicks: "11",
    clickToOrder: "—",
    imageColor: "#f2d4c8",
  },
  {
    id: "2",
    name: "Sticker Sheet of Fruity Candies",
    status: "advertising",
    sku: "9780735325906",
    dateAdded: "2024-01-08",
    wholesalePrice: "$4.99",
    impressions: "218",
    ctr: "3.2%",
    clicks: "7",
    clickToOrder: "—",
    imageColor: "#f8e8b0",
  },
  {
    id: "3",
    name: "Andy Warhol Playing Cards",
    status: "advertising",
    sku: "9780735380486",
    dateAdded: "2024-06-03",
    wholesalePrice: "$11.99",
    impressions: "162",
    ctr: "5.6%",
    clicks: "9",
    clickToOrder: "—",
    imageColor: "#f5c4d8",
  },
  {
    id: "4",
    name: "Flip & Find: Rainbow Garden",
    status: "advertising",
    sku: "9780735380585",
    dateAdded: "2024-10-21",
    wholesalePrice: "$9.39",
    impressions: "137",
    ctr: "6.6%",
    clicks: "9",
    clickToOrder: "—",
    imageColor: "#c8e8d8",
  },
  {
    id: "5",
    name: "A Little Book of Joys: Mother's Day Edition",
    status: "advertising",
    sku: "77940172",
    dateAdded: "2026-05-25",
    wholesalePrice: "$10.39",
    impressions: "123",
    ctr: "5.7%",
    clicks: "7",
    clickToOrder: "12.5%",
    imageColor: "#f0d8e0",
  },
  {
    id: "6",
    name: "24-piece Tin Tea Set",
    status: "advertising",
    sku: "9780735380615",
    dateAdded: "2026-06-12",
    wholesalePrice: "$26.19",
    impressions: "101",
    ctr: "4.0%",
    clicks: "4",
    clickToOrder: "—",
    imageColor: "#d8dce8",
  },
  {
    id: "7",
    name: "Andy Warhol Banana Puzzle",
    status: "excluded",
    sku: "9780735380462",
    dateAdded: "2025-07-18",
    wholesalePrice: "$20.99",
    impressions: "88",
    ctr: "1.1%",
    clicks: "1",
    clickToOrder: "—",
    imageColor: "#f8f0a8",
  },
  {
    id: "8",
    name: "Fifty United States Sticker Sheet",
    status: "unpublished",
    sku: "9780735380387",
    dateAdded: "2026-07-01",
    wholesalePrice: "$4.99",
    impressions: "33",
    ctr: "3.0%",
    clicks: "1",
    clickToOrder: "—",
    imageColor: "#e0e8f0",
  },
  {
    id: "9",
    name: "Keith Haring Assorted Sticker Sheet",
    status: "advertising",
    sku: "9780735380721",
    dateAdded: "2023-11-20",
    wholesalePrice: "$4.99",
    impressions: "194",
    ctr: "4.1%",
    clicks: "8",
    clickToOrder: "—",
    imageColor: "#f8c8a0",
  },
  {
    id: "10",
    name: "Van Gogh Starry Night 500-Piece Puzzle",
    status: "advertising",
    sku: "9780735380332",
    dateAdded: "2024-03-14",
    wholesalePrice: "$18.99",
    impressions: "176",
    ctr: "5.1%",
    clicks: "9",
    clickToOrder: "8.3%",
    imageColor: "#b8c8e8",
  },
  {
    id: "11",
    name: "Passion Flower Hardcover Journal",
    status: "advertising",
    sku: "9780735380196",
    dateAdded: "2024-05-09",
    wholesalePrice: "$14.99",
    impressions: "148",
    ctr: "3.4%",
    clicks: "5",
    clickToOrder: "—",
    imageColor: "#e8d0e0",
  },
  {
    id: "12",
    name: "Roses & Tulips 1000-Piece Puzzle",
    status: "advertising",
    sku: "9780735380554",
    dateAdded: "2024-08-27",
    wholesalePrice: "$22.99",
    impressions: "129",
    ctr: "4.7%",
    clicks: "6",
    clickToOrder: "—",
    imageColor: "#f0b8c8",
  },
  {
    id: "13",
    name: "Monet Water Lilies Boxed Notes",
    status: "advertising",
    sku: "9780735380270",
    dateAdded: "2026-06-05",
    wholesalePrice: "$12.99",
    impressions: "112",
    ctr: "3.6%",
    clicks: "4",
    clickToOrder: "—",
    imageColor: "#c8e0d8",
  },
  {
    id: "14",
    name: "Birth Month Flower Sticker Sheet",
    status: "excluded",
    sku: "9780735380646",
    dateAdded: "2025-01-22",
    wholesalePrice: "$4.99",
    impressions: "76",
    ctr: "2.6%",
    clicks: "2",
    clickToOrder: "—",
    imageColor: "#f5e0c8",
  },
  {
    id: "15",
    name: "Woodland Friends Birthday Card Assortment",
    status: "advertising",
    sku: "9780735380417",
    dateAdded: "2026-07-10",
    wholesalePrice: "$16.99",
    impressions: "94",
    ctr: "4.3%",
    clicks: "4",
    clickToOrder: "—",
    imageColor: "#d8e8c0",
  },
  {
    id: "16",
    name: "Frida Kahlo Magnet Set",
    status: "draft",
    sku: "9780735380691",
    dateAdded: "2026-06-15",
    wholesalePrice: "$8.99",
    impressions: "—",
    ctr: "—",
    clicks: "—",
    clickToOrder: "—",
    imageColor: "#e8c8b0",
  },
  {
    id: "17",
    name: "NYC Taxi Enamel Pin",
    status: "excluded",
    sku: "9780735380500",
    dateAdded: "2026-06-25",
    wholesalePrice: "$7.99",
    impressions: "61",
    ctr: "1.6%",
    clicks: "1",
    clickToOrder: "—",
    imageColor: "#f0e8a8",
  },
  {
    id: "18",
    name: "Celestial Skies Memo Notes",
    status: "unpublished",
    sku: "9780735380752",
    dateAdded: "2026-07-05",
    wholesalePrice: "$9.99",
    impressions: "28",
    ctr: "3.6%",
    clicks: "1",
    clickToOrder: "—",
    imageColor: "#d0d8f0",
  },
  {
    id: "19",
    name: "Matisse Cut-Outs Playing Cards",
    status: "advertising",
    sku: "9780735380448",
    dateAdded: "2026-06-20",
    wholesalePrice: "$11.99",
    impressions: "87",
    ctr: "5.7%",
    clicks: "5",
    clickToOrder: "10.0%",
    imageColor: "#f0c8d8",
  },
  {
    id: "20",
    name: "Spring Florals 12-Month Planner",
    status: "advertising",
    sku: "9780735380783",
    dateAdded: "2026-06-28",
    wholesalePrice: "$15.99",
    impressions: "72",
    ctr: "4.2%",
    clicks: "3",
    clickToOrder: "—",
    imageColor: "#e8f0c8",
  },
];

/**
 * REAL per-product ad metrics for the real-brand variants, from
 * ADS_SNAPSHOTS.MANAGER_METRICS_ADVERTISER_PRODUCT_METRICS (agg_range L12M,
 * snapshot 2026-08-18) joined to CANONICAL.PRODUCTS for the name, wholesale
 * price, and first-published date. Impressions, clicks, and conversions are the
 * platform's own; click-through and click-to-order rates are computed from
 * them. The brands don't expose a SKU in the warehouse, so the SKU column shows
 * the product token, which is the identifier the platform actually keys on.
 */
const KING_FLOYDS_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "kf-1",
    name: "Tempus Fugit Cocktail Cherries",
    status: "advertising",
    sku: "p_zeqaqtdve6",
    dateAdded: "2024-12-02",
    wholesalePrice: "$12.99",
    impressions: "5,567",
    ctr: "1.7%",
    clicks: "93",
    clickToOrder: "6.5%",
    imageColor: "#e8b4b8",
  },
  {
    id: "kf-2",
    name: "KING FLOYD’S Spicy Bloody Mary Peanuts",
    status: "advertising",
    sku: "p_7cazhr5hsh",
    dateAdded: "2021-11-17",
    wholesalePrice: "$7.19",
    impressions: "1,497",
    ctr: "2.7%",
    clicks: "41",
    clickToOrder: "9.8%",
    imageColor: "#d99a6c",
  },
  {
    id: "kf-3",
    name: "KING FLOYD’S Maple Bourbon Butter Toffee Peanuts",
    status: "advertising",
    sku: "p_t887uk2h9d",
    dateAdded: "2023-11-13",
    wholesalePrice: "$7.19",
    impressions: "1,693",
    ctr: "1.5%",
    clicks: "25",
    clickToOrder: "8.0%",
    imageColor: "#c99b5a",
  },
  {
    id: "kf-4",
    name: "KING FLOYD’S Dill Pickle Virginia Peanuts",
    status: "advertising",
    sku: "p_sce6nukbw6",
    dateAdded: "2021-11-17",
    wholesalePrice: "$7.19",
    impressions: "1,218",
    ctr: "2.1%",
    clicks: "25",
    clickToOrder: "8.0%",
    imageColor: "#b6c48a",
  },
  {
    id: "kf-5",
    name: "KING FLOYD’S Old Fashioned Bitters",
    status: "advertising",
    sku: "p_83vxyxv2r6",
    dateAdded: "2024-12-02",
    wholesalePrice: "$14.99",
    impressions: "898",
    ctr: "1.3%",
    clicks: "12",
    clickToOrder: "8.3%",
    imageColor: "#a9764a",
  },
  {
    id: "kf-6",
    name: "KING FLOYD’S Black Lava Rim Salt",
    status: "advertising",
    sku: "p_jmzc4umkma",
    dateAdded: "2021-11-17",
    wholesalePrice: "$7.19",
    impressions: "741",
    ctr: "1.6%",
    clicks: "12",
    clickToOrder: "—",
    imageColor: "#8d8d8d",
  },
  {
    id: "kf-7",
    name: "KING FLOYD’S Salty Virginia Peanuts",
    status: "advertising",
    sku: "p_dmacaqrxjq",
    dateAdded: "2021-11-17",
    wholesalePrice: "$7.19",
    impressions: "592",
    ctr: "1.4%",
    clicks: "8",
    clickToOrder: "—",
    imageColor: "#dcc7a0",
  },
  {
    id: "kf-8",
    name: "KING FLOYD’S Sea Flake Rim Salt",
    status: "advertising",
    sku: "p_akzh3kn3xe",
    dateAdded: "2021-11-17",
    wholesalePrice: "$4.79",
    impressions: "410",
    ctr: "2.0%",
    clicks: "8",
    clickToOrder: "—",
    imageColor: "#cfd6d9",
  },
  {
    id: "kf-9",
    name: "Abbott’s Aromatic Bitters",
    status: "advertising",
    sku: "p_jnez6zcu3z",
    dateAdded: "2024-12-02",
    wholesalePrice: "$9.99",
    impressions: "517",
    ctr: "1.0%",
    clicks: "5",
    clickToOrder: "—",
    imageColor: "#9c6b45",
  },
  {
    id: "kf-10",
    name: "KING FLOYD’S Scorched Pear and Ginger",
    status: "advertising",
    sku: "p_tb5vknj5tr",
    dateAdded: "2021-11-17",
    wholesalePrice: "$14.99",
    impressions: "385",
    ctr: "1.3%",
    clicks: "5",
    clickToOrder: "—",
    imageColor: "#d8c48c",
  },
  {
    id: "kf-11",
    name: "KING FLOYD’S Craft Bitters Old Fashioned Travel Set",
    status: "advertising",
    sku: "p_n9qq586v2y",
    dateAdded: "2025-07-31",
    wholesalePrice: "$24.99",
    impressions: "352",
    ctr: "1.4%",
    clicks: "5",
    clickToOrder: "20.0%",
    imageColor: "#b08968",
  },
  {
    id: "kf-12",
    name: "Ginger Bitters & Soda 4-Pack",
    status: "advertising",
    sku: "p_bfqnxden8t",
    dateAdded: "2025-12-22",
    wholesalePrice: "$7.16",
    impressions: "263",
    ctr: "1.9%",
    clicks: "5",
    clickToOrder: "20.0%",
    imageColor: "#e0b46c",
  },
];

const OGGI_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "og-1",
    name: "French Press 3 Cup Coffee Maker (350 ml, 12 oz) Green",
    status: "advertising",
    sku: "p_vmkm4s6fnz",
    dateAdded: "2024-02-06",
    wholesalePrice: "$8.25",
    impressions: "3,974",
    ctr: "1.5%",
    clicks: "58",
    clickToOrder: "3.4%",
    imageColor: "#8fae8b",
  },
  {
    id: "og-2",
    name: "French Press 5 Cup Borosilicate Coffee Maker (600 ml, 20 oz)",
    status: "advertising",
    sku: "p_v526yq643t",
    dateAdded: "2024-04-27",
    wholesalePrice: "$11.00",
    impressions: "1,973",
    ctr: "1.5%",
    clicks: "30",
    clickToOrder: "13.3%",
    imageColor: "#cfd6d9",
  },
  {
    id: "og-3",
    name: "French Press 3 Cup Coffee Maker (350 ml, 12 oz) Blue",
    status: "advertising",
    sku: "p_kgkefm6adf",
    dateAdded: "2024-02-06",
    wholesalePrice: "$8.25",
    impressions: "1,217",
    ctr: "1.4%",
    clicks: "17",
    clickToOrder: "—",
    imageColor: "#8ea6c4",
  },
  {
    id: "og-4",
    name: "French Press 3 Cup Coffee Maker (350 ml, 12 oz) Black",
    status: "advertising",
    sku: "p_hgmeu4v3ms",
    dateAdded: "2024-02-06",
    wholesalePrice: "$8.25",
    impressions: "1,085",
    ctr: "1.5%",
    clicks: "16",
    clickToOrder: "—",
    imageColor: "#6f7276",
  },
  {
    id: "og-5",
    name: "Stovetop Kettle — Steel, Wood Handle, Whistle (1.9 lt, 64 oz)",
    status: "advertising",
    sku: "p_fz7rbhqk42",
    dateAdded: "2024-04-27",
    wholesalePrice: "$22.00",
    impressions: "962",
    ctr: "1.6%",
    clicks: "15",
    clickToOrder: "13.3%",
    imageColor: "#b9915f",
  },
  {
    id: "og-6",
    name: "Moscow Mule Mug — Hammered Stainless Steel (530 ml, 18 oz)",
    status: "advertising",
    sku: "p_xg9qaskysq",
    dateAdded: "2024-01-24",
    wholesalePrice: "$8.25",
    impressions: "515",
    ctr: "2.3%",
    clicks: "12",
    clickToOrder: "25.0%",
    imageColor: "#c98c5a",
  },
  {
    id: "og-7",
    name: "Stovetop Kettle — Stainless Steel w/ Whistle (1.9 lt, 64 oz)",
    status: "advertising",
    sku: "p_59pwqwvmv8",
    dateAdded: "2024-07-15",
    wholesalePrice: "$22.00",
    impressions: "695",
    ctr: "1.4%",
    clicks: "10",
    clickToOrder: "10.0%",
    imageColor: "#a8adb2",
  },
  {
    id: "og-8",
    name: "French Press — 8 Cup Borosilicate Glass Coffee Maker — Green",
    status: "advertising",
    sku: "p_gtjzsv7het",
    dateAdded: "2025-11-05",
    wholesalePrice: "$13.12",
    impressions: "453",
    ctr: "2.0%",
    clicks: "9",
    clickToOrder: "11.1%",
    imageColor: "#7f9c78",
  },
  {
    id: "og-9",
    name: "Insulated Tumbler — ThermoMug Vacuum (420 ml, 14 oz) Floral",
    status: "advertising",
    sku: "p_3vjh6zu5kn",
    dateAdded: "2024-04-27",
    wholesalePrice: "$9.35",
    impressions: "307",
    ctr: "2.6%",
    clicks: "8",
    clickToOrder: "—",
    imageColor: "#e0b2c0",
  },
  {
    id: "og-10",
    name: "Cocktail Picks 20 pc Tropical — 4.5 in",
    status: "advertising",
    sku: "p_vnf5xcw472",
    dateAdded: "2024-06-12",
    wholesalePrice: "$2.20",
    impressions: "224",
    ctr: "3.6%",
    clicks: "8",
    clickToOrder: "—",
    imageColor: "#dcc47a",
  },
  {
    id: "og-11",
    name: "Compost Pail — Stainless Steel, Countertop (3.8 lt, 128 oz)",
    status: "advertising",
    sku: "p_mzpq2n4fw4",
    dateAdded: "2024-04-27",
    wholesalePrice: "$24.75",
    impressions: "373",
    ctr: "2.1%",
    clicks: "8",
    clickToOrder: "—",
    imageColor: "#9aa0a5",
  },
  {
    id: "og-12",
    name: "Japanese Jigger — 1 oz / 2 oz",
    status: "advertising",
    sku: "p_xrnnbs7ctd",
    dateAdded: "2024-01-30",
    wholesalePrice: "$4.40",
    impressions: "177",
    ctr: "4.0%",
    clicks: "7",
    clickToOrder: "28.6%",
    imageColor: "#c7ac6e",
  },
];

/**
 * Elana Gabrielle — REAL advertised catalog, same source and treatment as King
 * Floyd's above: the eight most-clicked products over the trailing 12 months.
 * Product names carry the brand's own SEO-ish phrasing; only repeated whitespace
 * has been collapsed.
 */
const ELANA_GABRIELLE_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "eg-1",
    name: "Floral Matchbox - Sage",
    status: "advertising",
    sku: "p_ajvavknm94",
    dateAdded: "2024-10-15",
    wholesalePrice: "$2.50",
    impressions: "2,961",
    ctr: "2.9%",
    clicks: "86",
    clickToOrder: "0.0%",
    imageColor: "#a8b89a",
  },
  {
    id: "eg-2",
    name: "Floating Acorn Candles",
    status: "advertising",
    sku: "p_3s9be8qucd",
    dateAdded: "2024-10-10",
    wholesalePrice: "$7.50",
    impressions: "2,055",
    ctr: "3.6%",
    clicks: "73",
    clickToOrder: "2.7%",
    imageColor: "#c9a86a",
  },
  {
    id: "eg-3",
    name: "Pastures Bandana - Western Cowgirl Landscape Accessory",
    status: "advertising",
    sku: "p_5hxj9ckjuy",
    dateAdded: "2023-08-30",
    wholesalePrice: "$16.00",
    impressions: "3,968",
    ctr: "1.8%",
    clicks: "71",
    clickToOrder: "0.0%",
    imageColor: "#d9a08a",
  },
  {
    id: "eg-4",
    name: "Pastures Greeting Card - Western Theme, Horse Illustration",
    status: "advertising",
    sku: "p_ttrkje8m3y",
    dateAdded: "2024-03-27",
    wholesalePrice: "$19.00",
    impressions: "1,494",
    ctr: "3.3%",
    clicks: "49",
    clickToOrder: "4.1%",
    imageColor: "#e0c9a6",
  },
  {
    id: "eg-5",
    name: "Tomato Tea Towel - Bestselling Bright Absorbent Linen",
    status: "advertising",
    sku: "p_vyebykvyca",
    dateAdded: "2021-07-13",
    wholesalePrice: "$19.00",
    impressions: "1,642",
    ctr: "2.5%",
    clicks: "41",
    clickToOrder: "2.4%",
    imageColor: "#d4574e",
  },
  {
    id: "eg-6",
    name: "Tomato Bandana - Bestselling Cotton Tomato Illustration",
    status: "advertising",
    sku: "p_6jjyvb5qab",
    dateAdded: "2024-10-10",
    wholesalePrice: "$16.00",
    impressions: "1,766",
    ctr: "2.0%",
    clicks: "36",
    clickToOrder: "8.3%",
    imageColor: "#c2453f",
  },
  {
    id: "eg-7",
    name: "Shells Matchbox",
    status: "advertising",
    sku: "p_dnspu74xka",
    dateAdded: "2026-02-14",
    wholesalePrice: "$2.50",
    impressions: "1,465",
    ctr: "2.1%",
    clicks: "31",
    clickToOrder: "6.5%",
    imageColor: "#e0cdb0",
  },
  {
    id: "eg-8",
    name: "Tides Bandana - Coastal Textile, Nature-Inspired Gift",
    status: "advertising",
    sku: "p_8zghhx64qh",
    dateAdded: "2021-09-28",
    wholesalePrice: "$16.00",
    impressions: "946",
    ctr: "3.0%",
    clicks: "28",
    clickToOrder: "3.6%",
    imageColor: "#8fa3b8",
  },
];

/**
 * Kaari & Co. — REAL advertised catalog, same source. Almost entirely $3
 * greeting cards, which is why the click-to-order rates run high on tiny click
 * counts — a $3 card converts far more readily than a $44 art print.
 */
const KAARI_CO_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "kc-1",
    name: "Trees of the Pacific Northwest Greeting Card - Eco Friendly",
    status: "advertising",
    sku: "p_ybcgwzumef",
    dateAdded: "2024-09-26",
    wholesalePrice: "$3.00",
    impressions: "1,344",
    ctr: "1.9%",
    clicks: "26",
    clickToOrder: "3.8%",
    imageColor: "#6f8f6a",
  },
  {
    id: "kc-2",
    name: "Happy Wedding - Floral Greeting Card - Eco-Friendly",
    status: "advertising",
    sku: "p_zztubgmgwh",
    dateAdded: "2026-06-27",
    wholesalePrice: "$3.00",
    impressions: "367",
    ctr: "6.5%",
    clicks: "24",
    clickToOrder: "25.0%",
    imageColor: "#e8c4cf",
  },
  {
    id: "kc-3",
    name: "Wildflowers of the Pacific Northwest Greeting Card",
    status: "advertising",
    sku: "p_nmatjvhs2a",
    dateAdded: "2024-06-25",
    wholesalePrice: "$3.00",
    impressions: "1,018",
    ctr: "1.6%",
    clicks: "16",
    clickToOrder: "6.3%",
    imageColor: "#c9b6d4",
  },
  {
    id: "kc-4",
    name: "Garden of Mushrooms Greeting Card",
    status: "advertising",
    sku: "p_umf3fve235",
    dateAdded: "2023-09-22",
    wholesalePrice: "$3.00",
    impressions: "390",
    ctr: "3.8%",
    clicks: "15",
    clickToOrder: "13.3%",
    imageColor: "#b8705f",
  },
  {
    id: "kc-5",
    name: "Birds of the Pacific Northwest Greeting Card",
    status: "advertising",
    sku: "p_jf5m69ytgv",
    dateAdded: "2025-05-21",
    wholesalePrice: "$3.00",
    impressions: "450",
    ctr: "2.9%",
    clicks: "13",
    clickToOrder: "7.7%",
    imageColor: "#7f9cb5",
  },
  {
    id: "kc-6",
    name: "Flowers in Her Arms Heirloom Art Print on Handmade Paper",
    status: "advertising",
    sku: "p_5je3b5d49d",
    dateAdded: "2025-08-28",
    wholesalePrice: "$44.00",
    impressions: "332",
    ctr: "3.6%",
    clicks: "12",
    clickToOrder: "0.0%",
    imageColor: "#e3d5c0",
  },
  {
    id: "kc-7",
    name: "Floral Whale - Waterproof Nature Sticker",
    status: "advertising",
    sku: "p_up6skqtv39",
    dateAdded: "2022-03-08",
    wholesalePrice: "$2.50",
    impressions: "411",
    ctr: "2.9%",
    clicks: "12",
    clickToOrder: "0.0%",
    imageColor: "#6d8fa8",
  },
  {
    id: "kc-8",
    name: "Wildflowers of Colorado Greeting Card",
    status: "advertising",
    sku: "p_3m5evjmdsr",
    dateAdded: "2024-08-29",
    wholesalePrice: "$3.00",
    impressions: "284",
    ctr: "3.5%",
    clicks: "10",
    clickToOrder: "0.0%",
    imageColor: "#d1a9b8",
  },
];

/**
 * The Woodsy Craft Co. — REAL advertised catalog, same source. A seasonal
 * catalog: the ornament kits were published in Sep and only draw clicks in the
 * run-up to the holidays, which is part of why acquisition is so lumpy.
 */
const WOODSY_CRAFT_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "wc-1",
    name: "DIY Craft Kit - Mushroom Garland",
    status: "advertising",
    sku: "p_ssm9zu6yp8",
    dateAdded: "2023-03-20",
    wholesalePrice: "$16.00",
    impressions: "3,840",
    ctr: "1.6%",
    clicks: "63",
    clickToOrder: "7.9%",
    imageColor: "#c0705f",
  },
  {
    id: "wc-2",
    name: "DIY Craft Kit - Folksy Flower Garland",
    status: "advertising",
    sku: "p_qpkawvxsk6",
    dateAdded: "2023-12-30",
    wholesalePrice: "$16.00",
    impressions: "2,637",
    ctr: "1.3%",
    clicks: "35",
    clickToOrder: "5.7%",
    imageColor: "#d9b45f",
  },
  {
    id: "wc-3",
    name: "DIY Ornament Kit - Christmas Spirit",
    status: "advertising",
    sku: "p_7y7wdkjcer",
    dateAdded: "2024-09-03",
    wholesalePrice: "$10.00",
    impressions: "771",
    ctr: "3.5%",
    clicks: "27",
    clickToOrder: "3.7%",
    imageColor: "#8a3f3f",
  },
  {
    id: "wc-4",
    name: "DIY Ornament Kit - Cozy Christmas",
    status: "advertising",
    sku: "p_ssvk2gwyet",
    dateAdded: "2024-09-03",
    wholesalePrice: "$10.00",
    impressions: "740",
    ctr: "3.0%",
    clicks: "22",
    clickToOrder: "4.5%",
    imageColor: "#5f7a5a",
  },
  {
    id: "wc-5",
    name: "DIY Craft Kit - Woodland Garland",
    status: "advertising",
    sku: "p_vtdzv3vz2c",
    dateAdded: "2023-01-23",
    wholesalePrice: "$16.00",
    impressions: "2,267",
    ctr: "0.9%",
    clicks: "20",
    clickToOrder: "10.0%",
    imageColor: "#7a6a4f",
  },
  {
    id: "wc-6",
    name: "DIY Craft Kit - The Vintage Ornament Kit",
    status: "advertising",
    sku: "p_na8gbjs9yu",
    dateAdded: "2025-08-12",
    wholesalePrice: "$16.00",
    impressions: "890",
    ctr: "1.7%",
    clicks: "15",
    clickToOrder: "0.0%",
    imageColor: "#b9a37f",
  },
  {
    id: "wc-7",
    name: "DIY Craft Kit - Heart Garland",
    status: "advertising",
    sku: "p_zwtgex6jhq",
    dateAdded: "2023-01-19",
    wholesalePrice: "$16.00",
    impressions: "838",
    ctr: "1.7%",
    clicks: "14",
    clickToOrder: "7.1%",
    imageColor: "#c96f84",
  },
  {
    id: "wc-8",
    name: "DIY Craft Kit - The Very Merry Kit",
    status: "advertising",
    sku: "p_kubdna4bvj",
    dateAdded: "2025-08-12",
    wholesalePrice: "$16.00",
    impressions: "772",
    ctr: "1.6%",
    clicks: "12",
    clickToOrder: "16.7%",
    imageColor: "#a34a4a",
  },
];

/**
 * Zotter Chocolates — REAL advertised catalog, same source (snapshot 2026-08-30).
 * Two counter displays and a $389 holiday bundle out-click the $6.48 bars they
 * exist to sell, and neither display has ever converted — the clearest example in
 * the set of clicks landing on merchandising rather than product.
 *
 * These are the eight most-clicked products that carry a publish date. Several
 * others in the top fifteen (the Labooko and Yuzu Citrus bars among them) have a
 * null `first_published_at` in CANONICAL.PRODUCTS, and the Date added column
 * shouldn't show a date the warehouse doesn't have.
 */
const ZOTTER_CHOCOLATES_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "zc-1",
    name: "Mixed display red - How to get it free",
    status: "advertising",
    sku: "p_d7t13vi79k",
    dateAdded: "2021-04-08",
    wholesalePrice: "$85.00",
    impressions: "5,896",
    ctr: "4.4%",
    clicks: "257",
    clickToOrder: "1.6%",
    imageColor: "#b23a3a",
  },
  {
    id: "zc-2",
    name: "Universal Counter Display black",
    status: "advertising",
    sku: "p_pwfk69s3uv",
    dateAdded: "2021-06-10",
    wholesalePrice: "$45.00",
    impressions: "3,178",
    ctr: "2.4%",
    clicks: "76",
    clickToOrder: "0.0%",
    imageColor: "#3a3a3a",
  },
  {
    id: "zc-3",
    name: "Holy Night - Burning Bright (Hand-scooped Chocolate)",
    status: "advertising",
    sku: "p_czexuajn91",
    dateAdded: "2022-10-20",
    wholesalePrice: "$6.48",
    impressions: "1,277",
    ctr: "3.0%",
    clicks: "38",
    clickToOrder: "2.6%",
    imageColor: "#6b4a7a",
  },
  {
    id: "zc-4",
    name: "6 Flavor Holiday/Christmas Chocolate Bars Bundle",
    status: "advertising",
    sku: "p_ds6xgs52hb",
    dateAdded: "2025-11-04",
    wholesalePrice: "$388.80",
    impressions: "797",
    ctr: "4.0%",
    clicks: "32",
    clickToOrder: "0.0%",
    imageColor: "#7a3f3f",
  },
  {
    id: "zc-5",
    name: "Whiskey + Caramel + Pecan (Hand-scooped Chocolate)",
    status: "advertising",
    sku: "p_75srdcm7pf",
    dateAdded: "2023-09-10",
    wholesalePrice: "$6.48",
    impressions: "1,579",
    ctr: "2.0%",
    clicks: "31",
    clickToOrder: "3.2%",
    imageColor: "#a9743f",
  },
  {
    id: "zc-6",
    name: "Whiskey Caramel Pecan 20g Mini (Hand-scooped chocolate)",
    status: "advertising",
    sku: "p_k2vs5uumsy",
    dateAdded: "2025-02-27",
    wholesalePrice: "$2.45",
    impressions: "1,779",
    ctr: "1.6%",
    clicks: "29",
    clickToOrder: "3.4%",
    imageColor: "#c08a4a",
  },
  {
    id: "zc-7",
    name: "Whiskey (Hand-scooped Chocolate)",
    status: "advertising",
    sku: "p_erub8ijleg",
    dateAdded: "2023-12-19",
    wholesalePrice: "$6.48",
    impressions: "1,941",
    ctr: "1.5%",
    clicks: "29",
    clickToOrder: "6.9%",
    imageColor: "#8b5a2b",
  },
  {
    id: "zc-8",
    name: "Display for Hand-scooped Chocolate Minis",
    status: "advertising",
    sku: "p_bg7u56pmjv",
    dateAdded: "2025-04-15",
    wholesalePrice: "$45.00",
    impressions: "891",
    ctr: "2.7%",
    clicks: "24",
    clickToOrder: "0.0%",
    imageColor: "#5c4433",
  },
];

/**
 * Dairy Brand — REAL advertised catalog, same source (snapshot 2026-09-17).
 * A plain top eight by clicks: every product in the top fifteen carries a publish
 * date, so unlike Zotter nothing had to be skipped.
 *
 * The inverse of Zotter's shape. Clicks land on the cheese itself rather than on
 * merchandising, and the click-to-order rates run three to eight times higher
 * across the board — a $3.97 gouda converts more than one click in ten. The top
 * eight is now all single cheeses and spreads: the $26.47 sampler that used to
 * place sixth has fallen out of the trailing window, and the newest listing here
 * (Chocstasy, published Nov 2025) is already eighth by clicks.
 */
const DAIRY_BRAND_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "db-1",
    name: "Smoked Gouda",
    status: "advertising",
    sku: "p_ywpernhyr5",
    dateAdded: "2023-02-13",
    wholesalePrice: "$3.97",
    impressions: "38,546",
    ctr: "1.2%",
    clicks: "454",
    clickToOrder: "6.4%",
    imageColor: "#b5763a",
  },
  {
    id: "db-2",
    name: "Golden Baked Bliss Cheese",
    status: "advertising",
    sku: "p_xzzwu8nnw7",
    dateAdded: "2023-11-28",
    wholesalePrice: "$5.47",
    impressions: "25,961",
    ctr: "1.7%",
    clicks: "445",
    clickToOrder: "4.9%",
    imageColor: "#d9a441",
  },
  {
    id: "db-3",
    name: "Bourbon Gouda",
    status: "advertising",
    sku: "p_mf8hjegbt9",
    dateAdded: "2023-03-22",
    wholesalePrice: "$3.97",
    impressions: "16,217",
    ctr: "1.9%",
    clicks: "314",
    clickToOrder: "11.1%",
    imageColor: "#8c5a2b",
  },
  {
    id: "db-4",
    name: "Yodel Parmesan Gruyere",
    status: "advertising",
    sku: "p_83mu5gu8jt",
    dateAdded: "2025-10-27",
    wholesalePrice: "$4.48",
    impressions: "24,548",
    ctr: "1.3%",
    clicks: "310",
    clickToOrder: "13.5%",
    imageColor: "#e0c169",
  },
  {
    id: "db-5",
    name: "Honey Sriracha Gouda",
    status: "advertising",
    sku: "p_rg56g9gudy",
    dateAdded: "2023-02-13",
    wholesalePrice: "$3.97",
    impressions: "18,863",
    ctr: "1.6%",
    clicks: "303",
    clickToOrder: "9.9%",
    imageColor: "#c8532c",
  },
  {
    id: "db-6",
    name: "Beer Cheddar Cheese Spread",
    status: "advertising",
    sku: "p_5qp3kg73hq",
    dateAdded: "2023-07-14",
    wholesalePrice: "$5.47",
    impressions: "22,634",
    ctr: "1.2%",
    clicks: "277",
    clickToOrder: "9.7%",
    imageColor: "#d98324",
  },
  {
    id: "db-7",
    name: "Cranberry Walnut Cheese Spread",
    status: "advertising",
    sku: "p_7egadtyh28",
    dateAdded: "2023-07-14",
    wholesalePrice: "$5.47",
    impressions: "19,052",
    ctr: "1.4%",
    clicks: "272",
    clickToOrder: "12.5%",
    imageColor: "#9b3b52",
  },
  {
    id: "db-8",
    name: "Chocstasy Chocolate Chip Dessert Cheese",
    status: "advertising",
    sku: "p_rf5beacy5c",
    dateAdded: "2025-11-19",
    wholesalePrice: "$3.95",
    impressions: "14,077",
    ctr: "1.8%",
    clicks: "255",
    clickToOrder: "10.2%",
    imageColor: "#6b4226",
  },
];

/**
 * Do Good Candle Studio — REAL advertised catalog, same source (snapshot
 * 2026-09-20). Top eight by clicks out of 89 advertised products.
 *
 * The only catalog here with no conversions anywhere in it: 2,562 impressions and
 * 45 clicks across the whole catalog over twelve months produced zero orders, so
 * every `clickToOrder` reads 0.0%. Nothing is wrong with the pull — the brand has
 * not converted an ad click since Apr 2024.
 *
 * The shape that is left is click-through, and the reed diffusers win it
 * decisively: the two $20 diffusers take the top spots on a fraction of the
 * impressions the candles get, one of them at 7.7% against a catalog that
 * otherwise runs under 2.5%.
 */
const DO_GOOD_CANDLE_PRODUCT_ROWS: ProductRow[] = [
  {
    id: "dgc-1",
    name: "Sweater Weather | Fall Reed Diffuser | Non-Toxic",
    status: "advertising",
    sku: "p_rw5xrq8g3y",
    dateAdded: "2026-07-16",
    wholesalePrice: "$20.00",
    impressions: "151",
    ctr: "4.0%",
    clicks: "6",
    clickToOrder: "0.0%",
    imageColor: "#c47a3f",
  },
  {
    id: "dgc-2",
    name: "Deck the Halls | Holiday Reed Diffuser | Non-Toxic",
    status: "advertising",
    sku: "p_yarac3pry3",
    dateAdded: "2026-07-16",
    wholesalePrice: "$20.00",
    impressions: "52",
    ctr: "7.7%",
    clicks: "4",
    clickToOrder: "0.0%",
    imageColor: "#2f5d4a",
  },
  {
    id: "dgc-3",
    name: "Sweater Weather | Fall Collection | Non-Toxic Soy Candle",
    status: "advertising",
    sku: "p_rp4qsw7e2e",
    dateAdded: "2025-09-18",
    wholesalePrice: "$15.24",
    impressions: "184",
    ctr: "1.6%",
    clicks: "3",
    clickToOrder: "0.0%",
    imageColor: "#b86a35",
  },
  {
    id: "dgc-4",
    name: "Car Diffuser",
    status: "advertising",
    sku: "p_6j65wvt6gw",
    dateAdded: "2026-07-18",
    wholesalePrice: "$7.00",
    impressions: "167",
    ctr: "1.8%",
    clicks: "3",
    clickToOrder: "0.0%",
    imageColor: "#8a8f98",
  },
  {
    id: "dgc-5",
    name: "Black Sea | Signature Black | Non-Toxic Soy Candle",
    status: "advertising",
    sku: "p_emva3srqw7",
    dateAdded: "2025-09-18",
    wholesalePrice: "$15.50",
    impressions: "140",
    ctr: "2.1%",
    clicks: "3",
    clickToOrder: "0.0%",
    imageColor: "#2b2f36",
  },
  {
    id: "dgc-6",
    name: "Cozy Hearth | Fall Collection Soy Candle | Non-Toxic",
    status: "advertising",
    sku: "p_r6jvv7rp23",
    dateAdded: "2025-09-18",
    wholesalePrice: "$15.24",
    impressions: "131",
    ctr: "2.3%",
    clicks: "3",
    clickToOrder: "0.0%",
    imageColor: "#9c4a2f",
  },
  {
    id: "dgc-7",
    name: "Sugared Apple | Fall Collection | Non-Toxic Soy Candle",
    status: "advertising",
    sku: "p_jhgx3nv5mk",
    dateAdded: "2025-09-18",
    wholesalePrice: "$15.25",
    impressions: "117",
    ctr: "2.6%",
    clicks: "3",
    clickToOrder: "0.0%",
    imageColor: "#a8323c",
  },
  {
    id: "dgc-8",
    name: "Lemon + Lavender | Signature White Collection | Soy Candle",
    status: "advertising",
    sku: "p_7t68svym92",
    dateAdded: "2025-09-18",
    wholesalePrice: "$15.50",
    impressions: "75",
    ctr: "4.0%",
    clicks: "3",
    clickToOrder: "0.0%",
    imageColor: "#c9b45e",
  },
];

/** Real catalogs where we have them, keyed by advertiser-profile token. */
export const REAL_BRAND_PRODUCT_ROWS: Record<string, ProductRow[]> = {
  [KING_FLOYDS_PROFILE_TOKEN]: KING_FLOYDS_PRODUCT_ROWS,
  [OGGI_PROFILE_TOKEN]: OGGI_PRODUCT_ROWS,
  [ELANA_GABRIELLE_PROFILE_TOKEN]: ELANA_GABRIELLE_PRODUCT_ROWS,
  [KAARI_CO_PROFILE_TOKEN]: KAARI_CO_PRODUCT_ROWS,
  [WOODSY_CRAFT_PROFILE_TOKEN]: WOODSY_CRAFT_PRODUCT_ROWS,
  [ZOTTER_CHOCOLATES_PROFILE_TOKEN]: ZOTTER_CHOCOLATES_PRODUCT_ROWS,
  [DAIRY_BRAND_PROFILE_TOKEN]: DAIRY_BRAND_PRODUCT_ROWS,
  [DO_GOOD_CANDLE_PROFILE_TOKEN]: DO_GOOD_CANDLE_PRODUCT_ROWS,
};
